const teamMembers = [
  {
    name: "Nour Al Farsi",
    nameAr: "نور الفارسي",
    role: "Creative Director & Master Stylist",
    roleAr: "مديرة إبداعية وصفيفة شعر محترفة",
    specialty: "Color & Balayage",
    image: "https://public.readdy.ai/ai/img_res/ab896c4dfbd695cddad3cf8eabccf4b9.jpg",
  },
  {
    name: "Hind Al Zadjali",
    nameAr: "هند الزدجالي",
    role: "Senior Colorist",
    roleAr: "متخصصة صبغ الشعر",
    specialty: "Highlights & Keratin",
    image: "https://readdy.ai/api/search-image?query=portrait%20confident%20young%20female%20beauty%20professional%20hairstylist%20middle%20eastern%2C%20warm%20friendly%20smile%2C%20natural%20light%20photography%2C%20modern%20salon%20setting%20oman&width=500&height=600&seq=bm_team002&orientation=portrait",
  },
  {
    name: "Maryam Al Busaidi",
    nameAr: "مريم البوسعيدي",
    role: "Skin & Wellness Expert",
    roleAr: "خبيرة البشرة والعناية",
    specialty: "Facials & Anti-Aging",
    image: "https://readdy.ai/api/search-image?query=portrait%20professional%20female%20aesthetician%20skin%20specialist%20middle%20eastern%2C%20elegant%20appearance%2C%20clean%20studio%20photo%2C%20confident%20posture%2C%20beauty%20wellness%20industry%20muscat%20oman&width=500&height=600&seq=bm_team003&orientation=portrait",
  },
  {
    name: "Salma Al Maqbali",
    nameAr: "سلمى المقبالي",
    role: "Nail Art & Lash Specialist",
    roleAr: "متخصصة الأظافر والرموش",
    specialty: "Nail Design & Lash Extensions",
    image: "https://readdy.ai/api/search-image?query=portrait%20smiling%20female%20nail%20technician%20beauty%20professional%20middle%20eastern%2C%20warm%20lighting%2C%20professional%20appearance%2C%20salon%20background%2C%20friendly%20expression%20oman&width=500&height=600&seq=bm_team004&orientation=portrait",
  },
];

export default function TeamSection() {
  return (
    <section id="team" className="py-16 sm:py-24 bg-[#f8f7f4]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-14">
          <p className="text-[#4a7fa5] text-xs tracking-[0.4em] uppercase mb-3 font-light">
            The Experts / خبراؤنا
          </p>
          <h2
            className="text-[#1a2744] text-3xl sm:text-4xl font-light tracking-wide"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Our Team
          </h2>
          <p
            className="text-[#1a2744] text-2xl font-bold mt-1"
            style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
          >
            فريق خبراء صالون القمر الأزرق
          </p>
          <p
            className="text-[#1a2744]/60 text-sm mt-1"
            style={{ fontFamily: "'Noto Naskh Arabic', serif", direction: "rtl" }}
          >
            متخصصون محترفون في التجميل والعناية بالبشرة والشعر في مسقط، الخوض
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
          {teamMembers.map((member) => (
            <div key={member.name} className="group cursor-pointer">
              <div className="relative overflow-hidden h-[260px] sm:h-[340px] mb-4">
                <img
                  src={member.image}
                  alt={`${member.name} - ${member.role} at Blue Moon Beauty Salon Muscat`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a2744]/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="text-center px-1">
                <h4 className="text-[#1a2744] font-semibold text-sm tracking-wide mb-0.5">{member.name}</h4>
                <p className="text-[#1a2744]/80 text-sm font-medium mb-1" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>{member.nameAr}</p>
                <p className="text-[#c6a864] text-xs tracking-widest uppercase font-light mb-0.5">{member.role}</p>
                <p className="text-gray-400 text-xs mb-0.5" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>{member.roleAr}</p>
                <p className="text-gray-400 text-xs">{member.specialty}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://api.whatsapp.com/send?phone=96892102051&text=Hello%20Blue%20Moon%20Beauty%20Salon%20%26%20Spa%2C%20I%20would%20like%20more%20information%20about%20your%20services."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 cursor-pointer whitespace-nowrap bg-[#1a2744] text-white text-xs tracking-[0.2em] uppercase px-8 py-3.5 hover:bg-[#243460] transition-colors duration-300"
          >
            <i className="ri-whatsapp-line text-base"></i>
            <span>Book with Our Team</span>
            <span className="opacity-80" style={{ fontFamily: "'Noto Naskh Arabic', serif" }}>— احجزي مع فريقنا</span>
          </a>
        </div>
      </div>
    </section>
  );
}
